<template>
  <div class="tabcut">
    <div class="tabTitle">
      <div
        :class="['sinTab',{'current':item.name==currentItem}]"
        v-for="item in tabList"
        :key="item.name"
        @click="cutItem(item.name)"
      >{{item.name}}</div>
    </div>
    <Area :tag="tag" v-show="currentItem=='区域监测'" />
    <Garden :tag="tag" v-show="currentItem=='园区监测'" :ref="'gardenPart'+tag"></Garden>
    <Invest :tag="tag" v-show="currentItem=='投资监测'" />
  </div>
</template>
<script>
import Garden from "@/components/tabCut/GardenModel/gardenModel1920.vue";
import Area from "@/components/tabCut/AreaModel/areaModel1920.vue";
import Invest from "@/components/tabCut/InvestModel/investModel1920.vue";
export default {
  props: ["current", "showMask"],
  components: {
    Garden,
    Area,
    Invest
  },
  data() {
    return {
      tabList: [
        {
          name: "区域监测"
        },
        {
          name: "投资监测"
        },
        {
          name: "园区监测"
        }
      ],
      tag:'',
      currentItem: "区域监测"
    };
  },
  methods: {
    cutItem(name) {
      this.currentItem = name;
    },
    cutRankItem(name) {
      this.currentRankItem = name;
    }
  },
  created() {
    this.currentItem = this.$props.current;
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.tabcut {
  // margin-top: 140px;
  // width: 2440px;
  width: 1920px;
  box-sizing: border-box;
  padding-top: 10px;
}
.tabTitle {
  display: flex;
  width: 468px;
  line-height: 28px;
  background: url(../../assets/imgs/background/tab_bg.png) center no-repeat;
  background-size: cover;
  padding: 0 90px;
  justify-content: space-between;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 236, 252, 1);
  .sinTab {
    cursor: pointer;
  }
  .sinTab.current {
    color: #ec9c45;
  }
}
.content {
  display: flex;
  margin-top: 36px;
}
.areaSurveyTitle {
  position: absolute;
  top: 17px;
  left: 17px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  z-index: 1200;
  display: flex;
  align-items: flex-end;
  .subTitle {
    margin-left: 15px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
  }
}
</style>